import React, { useEffect, useState } from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Step3Processing = ({ wizardData, updateWizardData, nextStep }) => {
  const [stage, setStage] = useState('Analyzing job description...');

  useEffect(() => {
    const process = async () => {
      try {
        // Step 1: Analyze JD
        setStage('Analyzing job description...');
        const analysisResponse = await axios.post(`${API}/analyze-jd`, {
          job_description: wizardData.jobDescription
        });
        const analysis = analysisResponse.data;
        updateWizardData({ analysis });

        // Step 2: Tailor Resume
        setStage('Tailoring your resume...');
        await new Promise(resolve => setTimeout(resolve, 1000));
        const tailorResponse = await axios.post(`${API}/tailor-resume`, {
          job_description: wizardData.jobDescription,
          resume_text: wizardData.resumeText,
          original_resume_data: {}
        });

        updateWizardData({
          tailoredResume: tailorResponse.data.tailored_text,
          toolsToValidate: tailorResponse.data.tools_to_validate || []
        });

        setStage('Complete!');
        await new Promise(resolve => setTimeout(resolve, 500));
        nextStep();
      } catch (error) {
        console.error('Processing error:', error);
        toast.error('Failed to process. Please try again.');
      }
    };

    process();
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[500px] space-y-8">
      <div className="relative">
        <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center animate-pulse">
          <Sparkles className="w-12 h-12 text-primary" />
        </div>
        <Loader2 className="w-32 h-32 text-primary/30 absolute -top-4 -left-4 animate-spin" />
      </div>

      <div className="text-center space-y-4">
        <h2 className="text-3xl font-bold tracking-tight">Processing Your Resume</h2>
        <p className="text-lg text-muted-foreground">{stage}</p>
      </div>

      <div className="w-full max-w-md">
        <div className="h-2 bg-slate-200 dark:bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full bg-primary rounded-full animate-pulse" style={{ width: '70%' }} />
        </div>
      </div>
    </div>
  );
};

export default Step3Processing;
